export default {
  events:[],
  errorEventsAPI:"",
}